// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
 

// / <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as FullStory from '@fullstory/browser';
import '@linuxfoundation/lfx-ui-core';

FullStory.init({ orgId: 'MDAHR', devMode: !environment.production });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  // tslint:disable-next-line: no-console
  .catch(err => console.error(err));
